import { faWarning } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from '@vetahealth/fishing-gear/colors'
import { Tooltip } from 'antd'

import styled from 'styled-components'

const AlertIconWrap = styled.span`
  margin: 0 4px;
`

export function AlertIcon({ message, messages = [] }: { message?: string; messages?: string[] }): React.ReactNode {
  const title = message || (
    <ul style={{ margin: 0, paddingLeft: 20, paddingRight: 10 }}>
      {messages.map((m) => (
        <li key={m}>{m}</li>
      ))}
    </ul>
  )

  return (
    <AlertIconWrap>
      <Tooltip title={title}>
        <FontAwesomeIcon icon={faWarning} color={Colors.ruby600} />
      </Tooltip>
    </AlertIconWrap>
  )
}
